import React, { useEffect, useRef } from "react";
import "./TextArea.css";

export const TextArea = ({
  label,
  required = false,
  value,
  defaultValue,
  placeholder,
  maxHeight = 120,
  onKeyDown,
  onChange,
  onPaste,
  onBlur,
  rows = 2,
  tagline,
  labelStyle,
  name,
  maxLength,
  allowPaste = true,
  readOnly = false,
  disabled = false,
  error,
  className = "",
}) => {
  const textareaRef = useRef(null);
  const isControlled = value !== undefined;
  const isReadOnly = readOnly || (isControlled && !onChange);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.height = `${Math.min(
      textarea.scrollHeight,
      Number(maxHeight) || 120,
    )}px`;
  }, [value, maxHeight]);

  const handleChange = (event) => {
    onChange?.(event);
  };

  const handlePaste = (event) => {
    if (!allowPaste) {
      event.preventDefault();
      return;
    }

    onPaste?.(event);
  };

  return (
    <div
      className={[
        "katch-form-textarea",
        disabled && "katch-form-textarea--disabled",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label && (
        <label className="katch-form-textarea__label" style={labelStyle}>
          {label}

          {required && <span className="katch-form-textarea__required">*</span>}
        </label>
      )}

      {tagline && (
        <span className="katch-form-textarea__tagline">{tagline}</span>
      )}

      <textarea
        ref={textareaRef}
        className="katch-form-textarea__field"
        name={name}
        value={isControlled ? (value ?? "") : undefined}
        defaultValue={!isControlled ? defaultValue : undefined}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        required={required}
        disabled={disabled}
        readOnly={isReadOnly}
        aria-invalid={Boolean(error)}
        style={{
          maxHeight:
            typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight,
        }}
        onChange={handleChange}
        onPaste={handlePaste}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
      />

      {error && (
        <span className="katch-form-textarea__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default TextArea;
